import React, { useState } from "react";
import Button from "../../../Other/element/Button";
const ChapterImagePreview = ({ url, type, closeHandler, show }) => {
  const onError = (e) => {
    console.log(e, "error in file-viewer");
  };

  const downloadFile = (url, type) => {
    if (!url.invalid) {
      let urldata = url;
      let aTag = document.createElement("a");
      aTag.href = urldata;
      aTag.download = type;
      aTag.click();
      aTag.remove();
    }
  };
  return (
    <>
      {show && (
        <div className="modal fade" role="dialog">
          <div className="course_modal-dialog modal-lg">
            <div className="course_modal-content file-viewer-content model-center">
              <div className="course_modal-header">
                <Button
                  handleClick={closeHandler}
                  title="Close"
                  className="btn next close-file"
                />
                <Button
                  handleClick={() => downloadFile(url, type)}
                  title="Download"
                  className="btn next"
                />
              </div>
              <div className="course_modal-body file-viewer-body">
                <img 
                  style={{
                    display: "block",
                    width: "95%",
                    height: "95%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  src={url}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ChapterImagePreview;
